/**
 * Mock for react-native-reanimated on web
 * This prevents webpack from trying to bundle reanimated code that's only needed for native
 */

// Export empty objects/functions for any reanimated imports
export const useSharedValue = () => ({ value: 0 });
export const useAnimatedStyle = () => ({});
export const withTiming = (value: any) => value;
export const withSpring = (value: any) => value;
export const runOnUI = (fn: any) => fn;
export const runOnJS = (fn: any) => fn;
export const Easing = {};

export default {};








